import { useState } from "react";
import { motion } from "framer-motion";
import { Mail } from "lucide-react";

export default function ComingSoon() {
  const GOOGLE_FORM_ACTION =
    "https://docs.google.com/forms/d/e/1FAIpQLSfjTBI8Xtw6W2mBo2KGzm4rukYhMn7_O6IkSOc53Q8yyyB7QA/formResponse";

  const EMAIL_FIELD_ID = "entry.285611299"; // field ID for email in Google Form

  const [email, setEmail] = useState("");
  const [status, setStatus] = useState(""); // "success", "error", ""

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("");

    try {
      const formData = new FormData();
      formData.append(EMAIL_FIELD_ID, email);

      await fetch(GOOGLE_FORM_ACTION, {
        method: "POST",
        mode: "no-cors", // required for Google Forms
        body: formData,
      });

      setStatus("success");
      setEmail("");
    } catch (err) {
      setStatus("error");
    }
  };

  return (
    <div className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-[#E1306C] via-[#E1306C]/80 to-black text-white font-inter px-4">
      {/* Background Overlay Pattern */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,_rgba(255,255,255,0.08),_transparent_50%)]" />

      <div className="relative max-w-3xl text-center">
        {/* Logo / Brand */}
        <motion.h1
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          className="text-5xl md:text-6xl font-extrabold tracking-tight mb-4"
        >
          Namasvi <span className="text-[#E1306C]">Nexus</span>
        </motion.h1>

        {/* Tagline */}
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 1 }}
          className="text-lg md:text-xl text-gray-200 mb-8"
        >
          The Influencer Engagement Platform for <br /> Brand Promotion & Collaboration
        </motion.p>

        {/* Coming Soon Text */}
        <motion.h2
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1, duration: 1 }}
          className="text-3xl md:text-4xl font-semibold mb-6"
        >
          🚀 We’re Launching Soon!
        </motion.h2>

        {/* Email Subscription Box */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1.3, duration: 1 }}
          className="flex flex-col items-center gap-2 max-w-md mx-auto"
        >
          <form onSubmit={handleSubmit} className="flex w-full">
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="flex-1 bg-transparent text-white px-4 py-2 outline-none placeholder-gray-300 border border-gray-400 rounded-l-xl"
            />
            <button
              type="submit"
              className="flex items-center gap-2 text-sm bg-[#E1306C] hover:bg-[#b32452] transition px-5 py-2 rounded-r-xl font-medium"
            >
              <Mail className="w-4 h-4" /> Notify Me
            </button>
          </form>

          {/* Status Message */}
          {status === "success" && (
            <p className="text-green-400 font-medium mt-2">
              ✅ Thank you! You’re now subscribed.
            </p>
          )}
          {status === "error" && (
            <p className="text-red-400 font-medium mt-2">
              ❌ Something went wrong. Please try again.
            </p>
          )}
        </motion.div>

        {/* Footer */}
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.6, duration: 1 }}
          className="mt-10 text-sm text-gray-400"
        >
          © {new Date().getFullYear()} Namasvi Nexus. All rights reserved.
        </motion.p>
      </div>
    </div>
  );
}
